/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const HomePageEvents = {
  view: 'view',
  tap: 'tap',
  click: 'click',
  // UHF Header Actions
  Profile_Click: 'Profile_Click',
  Wallet_Click: 'Wallet_Click',
  Search_Click: 'Search_Click',

  // Product Tiles
  Product_Tile_Click: 'Product_Tile_Click',
  Product_Tiles_Viewed: 'Product_Tiles_Viewed',
  Search_Tab_Click: 'Search_Tab_Click',
  Hero_Banner_Viewed: 'Hero_Banner_Viewed',
  Hero_Banner_Clicked: 'Hero_Banner_Clicked',
  Article_Carousel_Viewed: 'Article_Carousel_Viewed',
  Article_Carousel_Clicked: 'Article_Carousel_Clicked',
  Recommendation_Show_More_Clicked: 'Recommendation_Show_More_Clicked',
  spotlight_card_viewed: 'spotlight_card_viewed',
  //Notification Banner
  Notification_Banner_Viewed: 'Notification_Banner_Viewed',
  Notification_Banner_Clicked: 'Notification_Bannner_Clicked',
} as const;

export interface HomePageParams {
  label?: string;
  lob?: string;
  status?: string;
  bookingId?: string;
  ssoId?: string;
  rewardsTier?: string;
  bigPayId?: string;
  routePair?: string;
  travelDate?: string;
  productId?: string;
  position?: string | number;
  sectionTitle?: string;
  tabName?: string;
  quartile?: number;
  maxIndex?: number;
  recommendationType?: string;
  lobItemId?: string;
  tileName?: string;
  tag?: string;
  strikeThroughPrice?: string | number;
  price?: number;
  currency?: string;
  tileTitle?: string;
  tileDescription?: string;
  highlight?: string;
}

export const HOME_PAGE_CATEGORY = {
  uhf: 'uhf',
  spotlight_upcoming_orders: 'Spotlight|Upcoming Orders',
  spotlight_rewards_full: 'Spotlight|Rewards Full Height',
  spotlight_rewards_compact: 'Spotlight|Rewards Compact',
  spotlight_bigpay_full: 'Spotlight|BigPay Full Height',
  spotlight_bigpay_compact: 'Spotlight|BigPay Compact',
  spotlight_wallet_full: 'Spotlight|Wallet Full Height',
  spotlight_wallet_compact: 'Spotlight|Wallet Compact',
  spotlight_trip_full: 'Spotlight|Trip Full Height',
  spotlight_trip_compact: 'Spotlight|Trip Compact',
  homepage_product_tiles: 'homepage|productTiles',
  homepage_search_tab: 'homepage|searchTab',
  homepage_notification_banner: 'homepage|notificationBanner',
  homepage_hero_banner: 'homepage|heroBanner',
  homepage_article_carousel: 'homepage|articleCarousel',
  homepage_recommendation_tab: 'homepage|recommendationTab',
  recommendation_widget: 'recommendationWidget',
  recommendation_listing: 'recommendationListing',
  promotion_widget: 'promotionWidget',
  promotion_listing: 'promotionListing',
  footer_menu: 'footerMenu',
};

export const HOME_PAGE_SCREEN_NAME = {
  home: 'HomeV2',
};

export const HOME_PAGE_LABEL = {
  profile: 'profile',
  search: 'search',
  wallet: 'wallet',
};

export const EVENT_NAMES = {
  AA_ALL_APP_SCREENLOAD: 'aa_all_app_screenload',
  API_ERROR: 'API_ERROR',
} as const;
